import BitmovinPlayer from "./player";
import BitmovinNielsenPlugin from "../plugins/nielsen/BitmovinNielsenPlugin";
import BitmovinPlayNextPlugin from '../plugins/playnext/BitmovinPlayNextPlugin.js';
import BannerAd from "../bannerAd";
import {PalPlugin} from "../plugins/pal/PalPlugin";

class BitmovinMediaTailor extends BitmovinPlayer {
    player;
    mediaTailor;
    mediaTailorAds = [];
    avails = [];
    mediaTailorSession;
    debug = false;
    dataZoomKey = 'ce16da5a-fb96-4c1b-937f-ef4bf022c08e';
    datazoomContext;
    config;
    currentUiManager;
    currentMediaTailorAd;
    ssaiEnabled = true;
    //seekTarget=null;
    validEventTypes = [
        'impression',
        'start',
        'firstQuartile',
        'midpoint',
        'thirdQuartile',
        'complete'
    ];

    constructor(id, plugins) {
        super(id, plugins);
        if (this.plugins.includes('npaw') && typeof NpawPlugin !== "undefined") {
            this.npaw = new NpawPlugin('simplestream', {'components': {'balancer': false}})
        }
    }

    async ready() {
        console.log('BitmovinMediaTailor::ready()', this.data);

        if (this.data.streamsApiResponse?.ads?.ssai?.provider !== 'media-tailor') {
            this.ssaiEnabled = false;
            return await super.ready();
        }

        let mobileScreenCompanies = ['196'];

        if (mobileScreenCompanies.includes(this.data.playerApiResponse.company_id)) {
            if (this.isMobileBrowser()) {
                return this.mobileScreen(this.data.playerApiResponse.company_id);
            }
        }

        await this.initMediaTailor()
    }

    async initMediaTailor() {
        console.log('BitmovinMediaTailor::initMediaTailor()');

        this.mediaTailor = datazoom.mediatailor;
        //this.mediaTailor.setLogLevel(this.mediaTailor.LogLevel.DEBUG);

        datazoom.init({
            configuration_id: this.dataZoomKey,
            demo: "true"
        });

        this.adLabel = new bitmovin.playerui.AdMessageLabel({});

        this.mediaTailor.createSession(this.getSessionConfig()).then(session => {
                this.mediaTailorSession = session;
                const containerElement = document.getElementById('player-' + this.id)

                this.config = this.getConfig();

                this.setupChromecast();
                this.setLanguage();

                this.player = new bitmovin.player.Player(containerElement, this.config);

                this.setupNpaw();
                this.toggleUiManager();

                this.setNielsenAnalytics(this.data?.analyticsApiResponse?.nielsen_analytics);


                this.player.on(bitmovin.player.PlayerEvent.Ready, this.playerReady.bind(this));

                this.player.on(bitmovin.player.PlayerEvent.TimeChanged, (event) => {
                    this.loadingScreen.style.display = 'none'; // Hide loading screen when playback starts
                });

                // Disable any active subtitle when player is ready
                this.player.on(bitmovin.player.PlayerEvent.Ready, () => {
                    this.player.subtitles.off();
                });

                this.setupPlayerEvents();

                this.datazoomContext = datazoom.createContext(this.player);
                this.datazoomContext.attachMediaTailorSession(this.mediaTailorSession);

                this.source = this.getSource();
                console.warn(`Loading Source`, this.source);

                this.player.load(this.source);


                document.addEventListener("visibilitychange", () => {
                    if (!document.hidden && this.player.isPaused()) {
                        this.player.play()
                    }
                });

                window.addEventListener("destroySsmp", this.destroy.bind(this));

                /* Media Tailor Events (from the DataZoom SDK)
                 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

                // AD_TRACKING_INFO_RESPONSE
                this.mediaTailorSession.addEventListener(this.mediaTailor.SessionUiEvent.AD_TRACKING_INFO_RESPONSE, event => {
                    if (this.mediaTailorAds.length === 0) {
                        this.mediaTailorAds = this.mediaTailorSession.getAllAds();
                        this.setAds();
                        this.setAdPods();
                        this.setMarkers()
                    }
                });

                // AD_START
                this.mediaTailorSession.addEventListener(this.mediaTailor.SessionUiEvent.AD_START, event => {
                    console.warn("MediaTailor AD_START: " + event.detail.adElapsedTime, event.detail);
                    this.currentMediaTailorAd = event.detail.adObject;
                    this.toggleUiManager(true);
                });

                // AD_PROGRESS
                this.mediaTailorSession.addEventListener(this.mediaTailor.SessionUiEvent.AD_PROGRESS, event => {
                    console.warn('MediaTailor AD_PROGRESS');
                    const text = `<span class='ad-label'>Ad</span> ${this.currentMediaTailorAd.adData.availAdIndex + 1} of ${this.currentMediaTailorAd.adData.availAdCount} (${this.formatSeconds(Math.round(event.detail.adCountdown.toAdEnd))})`;
                    this.adLabel.setText(text);
                });

                // AD_CLICK
                this.mediaTailorSession.addEventListener(this.mediaTailor.SessionUiEvent.AD_CLICK, event => {
                    console.warn('MediaTailor AD_CLICK');
                });

                // AD_END
                this.mediaTailorSession.addEventListener(this.mediaTailor.SessionUiEvent.AD_END, event => {
                    console.warn('MediaTailor AD_END');
                    this.toggleUiManager();

                    // Return user to seekTarget after all ads have finished
                    if (this.isLastAdInPod(event.detail)) {
                        this.setAdPodAsWatched();
                        if (this.seekTarget) {
                            this.player.seek(this.seekTarget);
                            this.seekTarget = null;
                        }
                    }

                    this.currentMediaTailorAd = null;
                });

                /* Bitmovin Ad Break Events
                 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

                this.player.on(bitmovin.player.PlayerEvent.AdBreakStarted, (event) => {
                    this.toggleUiManager(true)
                    this.adLabel.show();
                });

                this.player.on(bitmovin.player.PlayerEvent.AdBreakFinished, (event) => {
                    this.player.unload();
                    this.player.load(this.getSource());
                    this.toggleUiManager();
                });

                /* Prevent Ad Skipping
                 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

                this.player.on(bitmovin.player.PlayerEvent.Seek, (event) => {
                    if(event.issuer !== 'ui') {
                        this.seekTarget = null;
                        return;
                    }

                    this.seekTarget = event.seekTarget;

                    const closestUnwatched = this.findClosestPastUnwatchedAvail(event.seekTarget);

                    if(closestUnwatched) {
                        this.player.seek(closestUnwatched.availStart);
                        closestUnwatched.watched = true;
                    }
                });

            },
            error => {
                console.error(`Mediatailor Session initialization error`, error);
            });
    }

    getSessionConfig() {
        const mediatailorSessionURL = this.data.streamsApiResponse.ads?.ssai?.prefix +
            this.data.streamsApiResponse.ads?.ssai?.session;

        return {
            sessionInitUrl: mediatailorSessionURL,
            originParams: {
                adsParams: this.data.streamsApiResponse?.ads?.ssai?.postBody?.adsParams,
            },
            playerParams: this.data.streamsApiResponse?.ads?.ssai?.postBody?.adsParams,
            incomingAdCountdownInterval: 10
        }
    }

    setupNpaw() {
        console.log('BitmovinMediaTailor::setupNpaw()');
        if (this.npaw) {
            this.npaw.setLogLevel(LogLevel.DEBUG);
            this.npaw.registerAdapterFromClass(this.player, NpawPluginAdapters.video.Bitmovin, null, this.id, () => {
                if (this.data?.analyticsApiResponse) {
                    let videoOptions = {...this.data.analyticsApiResponse}
                    delete videoOptions['accountCode'];
                    delete videoOptions['nielsen_analytics'];
                    console.log('NPAW', videoOptions);
                    this.npaw.setVideoOptions(videoOptions, this.id);
                } else {
                    console.warn('analyticsApiResponse is not defined or is null');
                }
            });
        }
    }

    setLanguage() {
        console.log('BitmovinMediaTailor::setLanguage()');
        let language = 'auto';
        try {
            const analytics = JSON.parse(this.data.attributes.analytics);
            language = analytics.language?.split('-')[0] ?? 'auto';
        } catch (e) {
            console.log('Invalid analytics data. Skipping.');
        }
        bitmovin.playerui.i18n.setConfig({
            language: language,
        });
    }

    setNielsenAnalytics(contentMetadata) {
        console.log('BitmovinMediaTailor::setNielsenAnalytics()');
        if (!this.data?.analyticsApiResponse?.nielsen_analytics || !this.plugins.includes('nielsen')) {
            return;
        }

        let options = {
            apid: this.data.attributes?.nielsenApid,
            player: this.player,
            contentMetadata: contentMetadata,
        };

        if (this.ssaiEnabled) {
            Object.assign(options, {
                mediaTailor: {
                    mediatailor: this.mediaTailor,
                    session: this.mediaTailorSession
                }
            })
        }
        new BitmovinNielsenPlugin(options);
    }

    setHeartbeat(data) {
        console.log('BitmovinMediaTailor::setHeartbeat()');
        if (!this.data.streamsApiResponse?.heartbeat?.url) {
            console.warn('No heartbeat API response found');
        }

        Object.assign(this.data, {
            video: this.player.getVideoElement()
        });

        super.setHeartbeat(data);
    }

    setBannerAds(data) {
        let generatedNonce;
        const hasBanner =
            this.bannerAdsEnabled &&
            this.data.attributes.type !== 'live' &&
            this.data.streamsApiResponse?.ads?.banner?.vast &&
            (this.data.streamsApiResponse?.metadata?.company_id !== undefined &&
                this.data.streamsApiResponse.metadata.company_id === 196);

        if (!hasBanner) return;

        // Create Banner Ad Container
        this.bannerAdContainer = document.createElement('div');
        this.bannerAdContainer.classList.add('banner-ad-container');
        this.playerContainer.appendChild(this.bannerAdContainer);

        let options = {
            'container': this.bannerAdContainer,
            'videoElement': this.videoElement,
            'vastTag': this.data.streamsApiResponse.ads.banner.vast,
            'streamsApiResponse': this.data.streamsApiResponse,
            'nonce': generatedNonce ?? null, // Token for PAL SDK
            'player': this.player
        };

        if (hasBanner) {
            if (this.ssaiEnabled) {
                Object.assign(options, {
                    mediaTailor: {
                        mediatailor: this.mediaTailor,
                        session: this.mediaTailorSession
                    }
                })
            }

            new BannerAd(options);
        }

        PalPlugin()
            .then((nonce) => {
                generatedNonce = this.nonceRequest(data, nonce);
                console.log('...Generated nonce for PAL SDK:', generatedNonce);
            })
            .catch((error) => {
                console.error('...Failed to load nonce:', error);
            });
    }

    nonceRequest(data, nonce) {
        return data.streamsApiResponse.ads?.pause?.vast + "&givn=" + nonce;
    }

    /**
     * Called when the player is ready
     * @returns {void}
     */
    playerReady() {
        console.log('BitmovinMediaTailor::playerReady()');
        if (!this.isLive && !this.playPositionSet) {
            const seekTo = parseInt(this.data.attributes?.position ?? 0);
            if(seekTo > 0){
                setTimeout(() => {
                    this.player.seek(seekTo);
                }, 500);
            }
            this.playPositionSet = true;
        }

        // Ensure videoElement is set for banner ads
        this.videoElement = this.player.getVideoElement();

        window.dispatchEvent(new CustomEvent('ssmp-player-ready', {
            detail: {
                videoElement: this.videoElement,
                playerData: this.data
            }
        }));
        this.setupPlayerEvents();
        this.setHeartbeat(this.data);
        this.setBannerAds(this.data);

        /*
        PalPlugin()
            .then((nonce) => {
                //generatedNonce = this.data.streamsApiResponse.ads?.pause?.vast + "&givn=" + nonce;
            })
            .catch((error) => {
                console.error('...Failed to load nonce:', error);
            });*/

        this.bitmovinPauseAdPlugin.ready(this.data.streamsApiResponse.ads.pause.vast, {
            mediatailor: this.mediaTailor,
            session: this.mediaTailorSession
        });

        new BitmovinPlayNextPlugin({
            'parent': this, // Parent class
            'container': this.aspectRatioContainerContent, // Container in which to render the play next button
            'videoElement': this.player.getContainer().querySelector('video'), // Video element
            'playerApiResponse': this.data.playerApiResponse, // Response from the Player API
            'attributes': this.data.attributes, // Data attributes from the embed code
        });
    }

    toggleUiManager(isAd = false) {

        if (this.currentUiManager) {
            this.currentUiManager.release();
        }

        if (!isAd) {
            this.currentUiManager = bitmovin.playerui.UIFactory.buildDefaultUI(this.player);
            if (this.mediaTailorAds.length > 0) {
                this.setMarkers();
            }
        } else {
            let components = [
                new bitmovin.playerui.BufferingOverlay(),
                new bitmovin.playerui.Container({
                    components: [
                        this.adLabel,
                    ],
                    cssClass: 'ui-ads-status',
                }),
                new bitmovin.playerui.ControlBar({
                    components: [
                        new bitmovin.playerui.Container({
                            components: [
                                new bitmovin.playerui.PlaybackToggleButton(),
                                new bitmovin.playerui.VolumeToggleButton(),
                                new bitmovin.playerui.VolumeSlider(),
                            ],
                            cssClasses: ['controlbar-bottom'],
                        }),
                    ],
                    cssClasses: ['adControlBar']
                })
            ];

            if (this.currentMediaTailorAd?.adClickthroughUrl) {

                const adClickUrl = this.currentMediaTailorAd?.adClickthroughUrl;
                if (adClickUrl) {
                    // 1) keep the visual overlay, but stop it from hijacking clicks
                    const overlay = new bitmovin.playerui.AdClickOverlay({
                        url: adClickUrl,
                        clickThrough: false
                    });

                    overlay.getDomElement().css('height', '80%');

                    components.push(overlay);

                    // 2) listen on the video element itself
                    this.player.on(bitmovin.player.PlayerEvent.Click, () => {
                        window.open(adClickUrl, '_blank');
                    });
                }
            }

            this.currentUiManager = new bitmovin.playerui.UIManager(this.player, [{
                ui: new bitmovin.playerui.UIContainer({
                    hideDelay: -1, // never hide controls
                    components: components,
                    cssClasses: ['ui-skin-ads'],
                    hidePlayerStateExceptions: [
                        bitmovin.playerui.PlayerUtils.PlayerState.Prepared,
                        bitmovin.playerui.PlayerUtils.PlayerState.Playing,
                        bitmovin.playerui.PlayerUtils.PlayerState.Finished,
                    ],
                }),
            }]);
        }
    }

    getSource() {
        if (!this.ssaiEnabled) {
            return super.getSource();
        }
        this.source = super.getSource();
        const playbackUrl = this.mediaTailorSession?.getPlaybackUrl() ?? null;
        if (playbackUrl && playbackUrl.includes('.mpd')) {
            Object.assign(this.source, {
                dash: playbackUrl,
            });
        } else {
            Object.assign(this.source, {
                hls: playbackUrl,
            });
        }
        return this.source;
    }

    /**
     * Convert seconds to a formatted string (mm:ss)
     * @param {number} seconds - The number of seconds to format.
     * @returns {string} The formatted time string in mm:ss format.
     */
    formatSeconds(seconds) {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs.toString().padStart(2, '0')}`;
    }

    /**
     * Render midroll markers on the timeline
     * @returns {void}
     */
    setMarkers() {
        console.log('BitmovinMediaTailor::setMarkers()');
        this.mediaTailorAds.forEach((ad) => {
            this.avails.forEach((avail) => {
                this.currentUiManager.addTimelineMarker({
                    time: avail.availStart,
                    duration: avail.availDuration,
                });
            });
        });
    }

    setAds() {
        console.log(`BitmovinMediaTailor::setAds() -  Video Contains ${this.mediaTailorAds.length} Ads`);

        this.mediaTailorAds.forEach((ad) => {
            if (!this.avails.some(item => item.availStart === ad.availStart)) {
                this.avails.push({
                    availStart: ad.availStart,
                    availDuration: ad.availDuration,
                    watched: false,
                });
            }
        });
    }

    /**
     * Format mediaTailorAds to be groupd by pod
     * @returns {Array}
     */
    setAdPods() {
        console.log(`BitmovinMediaTailor::setAdPods()`);

        const groups = this.mediaTailorAds.reduce((acc, ad) => {
            const prefix = ad.adId.slice(0, ad.adId.lastIndexOf('_'));
            (acc[prefix] ||= []).push(ad);
            return acc;
        }, {});

        this.adPods = Object.entries(groups).map(([prefix, items], index) => {
            // Ensure order by numeric suffix (_0, _1, _2, …)
            items.sort((a, b) => {
                const ai = parseInt(a.adId.split('_').pop(), 10);
                const bi = parseInt(b.adId.split('_').pop(), 10);
                return ai - bi;
            });

            const podStart = Math.round(Number(items[0]?.availStart) || 0);
            const podDuration = Math.round(
                items.reduce((sum, ad) => sum + (Number(ad.duration) || 0), 0)
            );
            const podEnd = podStart + podDuration;

            return {
                podIndex: index + 1,
                podId: prefix,
                podStartFormatted: this.formatSeconds(podStart),
                podEndFormatted: this.formatSeconds(podEnd),
                podStart,
                podDuration,
                podEnd,
                podWatched: false,
                ads: items
            };
        });

        console.log(this.adPods);
        return this.adPods;
    }

    setAdPodAsWatched() {
        console.log(`BitmovinMediaTailor::markPodUnwatched()`);
        this.adPods = this.adPods.map(pod => {
            const containsAd = pod.ads.some(ad => ad.adId === this.currentMediaTailorAd.adData.adId);
            return containsAd ? {...pod, podWatched: true} : pod;
        });
    }

    findClosestPastUnwatchedAvail(currentTime) {
        const pastUnwatchedAvails = this.avails.filter(avail =>
            avail.availStart <= currentTime && !avail.watched
        );

        if (pastUnwatchedAvails.length === 0) {
            return null;
        }

        return pastUnwatchedAvails.reduce((closest, current) =>
            current.availStart > closest.availStart ? current : closest
        );
    }

    isLastAdInPod(ad) {
        console.log(`BitmovinMediaTailor::isLastAdInPod()`);
        let lastAdInPod = false;
        if (ad.adObject?.adData) {
            if (ad.adObject.adData.availAdCount === (ad.adObject.adData.availAdIndex + 1)) {
                lastAdInPod = true;
            }
        }
        return lastAdInPod;
    }

    /**
     * Destroys the Bitmovin player instance and cleans up resources.
     * @returns {Promise<void>}
     */

    async destroy() {
        console.log('BitmovinPlayer::destroy()');

        if (this.datazoomContext) {
            this.datazoomContext.destroy();
            this.datazoomContext = null;
        }

        if (this.npaw) {
            this.npaw.destroy();
        }

        if (this.streamManager) {
            this.streamManager.reset();
        }

        if (this.player) {
            await this.player.destroy();
            this.player = null;
        }
    }
}

export default BitmovinMediaTailor;